export default {
	"Abkhazian": {
		"name": "Abkhazian",
		"names": ["Abkhazian"],
		"iso639-2": "abk",
		"iso639-1": "ab"
	},
	"Achinese": {
		"name": "Achinese",
		"names": ["Achinese"],
		"iso639-2": "ace",
		"iso639-1": null
	},
	"Acoli": {
		"name": "Acoli",
		"names": ["Acoli"],
		"iso639-2": "ach",
		"iso639-1": null
	},
	"Adangme": {
		"name": "Adangme",
		"names": ["Adangme"],
		"iso639-2": "ada",
		"iso639-1": null
	},
	"Adygei": {
		"name": "Adygei",
		"names": ["Adyghe", "Adygei"],
		"iso639-2": "ady",
		"iso639-1": null
	},
	"Adyghe": {
		"name": "Adyghe",
		"names": ["Adyghe", "Adygei"],
		"iso639-2": "ady",
		"iso639-1": null
	},
	"Afar": {
		"name": "Afar",
		"names": ["Afar"],
		"iso639-2": "aar",
		"iso639-1": "aa"
	},
	"Afrihili": {
		"name": "Afrihili",
		"names": ["Afrihili"],
		"iso639-2": "afh",
		"iso639-1": null
	},
	"Afrikaans": {
		"name": "Afrikaans",
		"names": ["Afrikaans"],
		"iso639-2": "afr",
		"iso639-1": "af"
	},
	"Afro-Asiatic languages": {
		"name": "Afro-Asiatic languages",
		"names": ["Afro-Asiatic languages"],
		"iso639-2": "afa",
		"iso639-1": null
	},
	"Ainu": {
		"name": "Ainu",
		"names": ["Ainu"],
		"iso639-2": "ain",
		"iso639-1": null
	},
	"Akan": {
		"name": "Akan",
		"names": ["Akan"],
		"iso639-2": "aka",
		"iso639-1": "ak"
	},
	"Akkadian": {
		"name": "Akkadian",
		"names": ["Akkadian"],
		"iso639-2": "akk",
		"iso639-1": null
	},
	"Albanian": {
		"name": "Albanian",
		"names": ["Albanian"],
		"iso639-2": "alb/sqi",
		"iso639-1": "sq"
	},
	"Alemannic": {
		"name": "Alemannic",
		"names": ["Swiss German", "Alemannic", "Alsatian"],
		"iso639-2": "gsw",
		"iso639-1": null
	},
	"Aleut": {
		"name": "Aleut",
		"names": ["Aleut"],
		"iso639-2": "ale",
		"iso639-1": null
	},
	"Algonquian languages": {
		"name": "Algonquian languages",
		"names": ["Algonquian languages"],
		"iso639-2": "alg",
		"iso639-1": null
	},
	"Alsatian": {
		"name": "Alsatian",
		"names": ["Swiss German", "Alemannic", "Alsatian"],
		"iso639-2": "gsw",
		"iso639-1": null
	},
	"Altaic languages": {
		"name": "Altaic languages",
		"names": ["Altaic languages"],
		"iso639-2": "tut",
		"iso639-1": null
	},
	"Amharic": {
		"name": "Amharic",
		"names": ["Amharic"],
		"iso639-2": "amh",
		"iso639-1": "am"
	},
	"Angika": {
		"name": "Angika",
		"names": ["Angika"],
		"iso639-2": "anp",
		"iso639-1": null
	},
	"Apache languages": {
		"name": "Apache languages",
		"names": ["Apache languages"],
		"iso639-2": "apa",
		"iso639-1": null
	},
	"Arabic": {
		"name": "Arabic",
		"names": ["Arabic"],
		"iso639-2": "ara",
		"iso639-1": "ar"
	},
	"Aragonese": {
		"name": "Aragonese",
		"names": ["Aragonese"],
		"iso639-2": "arg",
		"iso639-1": "an"
	},
	"Arapaho": {
		"name": "Arapaho",
		"names": ["Arapaho"],
		"iso639-2": "arp",
		"iso639-1": null
	},
	"Arawak": {
		"name": "Arawak",
		"names": ["Arawak"],
		"iso639-2": "arw",
		"iso639-1": null
	},
	"Armenian": {
		"name": "Armenian",
		"names": ["Armenian"],
		"iso639-2": "arm/hye",
		"iso639-1": "hy"
	},
	"Aromanian": {
		"name": "Aromanian",
		"names": ["Aromanian", "Arumanian", "Macedo-Romanian"],
		"iso639-2": "rup",
		"iso639-1": null
	},
	"Artificial languages": {
		"name": "Artificial languages",
		"names": ["Artificial languages"],
		"iso639-2": "art",
		"iso639-1": null
	},
	"Arumanian": {
		"name": "Arumanian",
		"names": ["Aromanian", "Arumanian", "Macedo-Romanian"],
		"iso639-2": "rup",
		"iso639-1": null
	},
	"Assamese": {
		"name": "Assamese",
		"names": ["Assamese"],
		"iso639-2": "asm",
		"iso639-1": "as"
	},
	"Asturian": {
		"name": "Asturian",
		"names": ["Asturian", "Bable", "Leonese", "Asturleonese"],
		"iso639-2": "ast",
		"iso639-1": null
	},
	"Asturleonese": {
		"name": "Asturleonese",
		"names": ["Asturian", "Bable", "Leonese", "Asturleonese"],
		"iso639-2": "ast",
		"iso639-1": null
	},
	"Athapascan languages": {
		"name": "Athapascan languages",
		"names": ["Athapascan languages"],
		"iso639-2": "ath",
		"iso639-1": null
	},
	"Australian languages": {
		"name": "Australian languages",
		"names": ["Australian languages"],
		"iso639-2": "aus",
		"iso639-1": null
	},
	"Austronesian languages": {
		"name": "Austronesian languages",
		"names": ["Austronesian languages"],
		"iso639-2": "map",
		"iso639-1": null
	},
	"Avaric": {
		"name": "Avaric",
		"names": ["Avaric"],
		"iso639-2": "ava",
		"iso639-1": "av"
	},
	"Avestan": {
		"name": "Avestan",
		"names": ["Avestan"],
		"iso639-2": "ave",
		"iso639-1": "ae"
	},
	"Awadhi": {
		"name": "Awadhi",
		"names": ["Awadhi"],
		"iso639-2": "awa",
		"iso639-1": null
	},
	"Aymara": {
		"name": "Aymara",
		"names": ["Aymara"],
		"iso639-2": "aym",
		"iso639-1": "ay"
	},
	"Azerbaijani": {
		"name": "Azerbaijani",
		"names": ["Azerbaijani"],
		"iso639-2": "aze",
		"iso639-1": "az"
	},
	"Bable": {
		"name": "Bable",
		"names": ["Asturian", "Bable", "Leonese", "Asturleonese"],
		"iso639-2": "ast",
		"iso639-1": null
	},
	"Balinese": {
		"name": "Balinese",
		"names": ["Balinese"],
		"iso639-2": "ban",
		"iso639-1": null
	},
	"Baltic languages": {
		"name": "Baltic languages",
		"names": ["Baltic languages"],
		"iso639-2": "bat",
		"iso639-1": null
	},
	"Baluchi": {
		"name": "Baluchi",
		"names": ["Baluchi"],
		"iso639-2": "bal",
		"iso639-1": null
	},
	"Bambara": {
		"name": "Bambara",
		"names": ["Bambara"],
		"iso639-2": "bam",
		"iso639-1": "bm"
	},
	"Bamileke languages": {
		"name": "Bamileke languages",
		"names": ["Bamileke languages"],
		"iso639-2": "bai",
		"iso639-1": null
	},
	"Banda languages": {
		"name": "Banda languages",
		"names": ["Banda languages"],
		"iso639-2": "bad",
		"iso639-1": null
	},
	"Bantu languages": {
		"name": "Bantu languages",
		"names": ["Bantu languages"],
		"iso639-2": "bnt",
		"iso639-1": null
	},
	"Basa": {
		"name": "Basa",
		"names": ["Basa"],
		"iso639-2": "bas",
		"iso639-1": null
	},
	"Bashkir": {
		"name": "Bashkir",
		"names": ["Bashkir"],
		"iso639-2": "bak",
		"iso639-1": "ba"
	},
	"Basque": {
		"name": "Basque",
		"names": ["Basque"],
		"iso639-2": "baq/eus",
		"iso639-1": "eu"
	},
	"Batak languages": {
		"name": "Batak languages",
		"names": ["Batak languages"],
		"iso639-2": "btk",
		"iso639-1": null
	},
	"Bedawiyet": {
		"name": "Bedawiyet",
		"names": ["Beja", "Bedawiyet"],
		"iso639-2": "bej",
		"iso639-1": null
	},
	"Beja": {
		"name": "Beja",
		"names": ["Beja", "Bedawiyet"],
		"iso639-2": "bej",
		"iso639-1": null
	},
	"Belarusian": {
		"name": "Belarusian",
		"names": ["Belarusian"],
		"iso639-2": "bel",
		"iso639-1": "be"
	},
	"Bemba": {
		"name": "Bemba",
		"names": ["Bemba"],
		"iso639-2": "bem",
		"iso639-1": null
	},
	"Bengali": {
		"name": "Bengali",
		"names": ["Bengali"],
		"iso639-2": "ben",
		"iso639-1": "bn"
	},
	"Berber languages": {
		"name": "Berber languages",
		"names": ["Berber languages"],
		"iso639-2": "ber",
		"iso639-1": null
	},
	"Bhojpuri": {
		"name": "Bhojpuri",
		"names": ["Bhojpuri"],
		"iso639-2": "bho",
		"iso639-1": null
	},
	"Bihari languages": {
		"name": "Bihari languages",
		"names": ["Bihari languages"],
		"iso639-2": "bih",
		"iso639-1": "bh"
	},
	"Bikol": {
		"name": "Bikol",
		"names": ["Bikol"],
		"iso639-2": "bik",
		"iso639-1": null
	},
	"Bilin": {
		"name": "Bilin",
		"names": ["Blin", "Bilin"],
		"iso639-2": "byn",
		"iso639-1": null
	},
	"Bini": {
		"name": "Bini",
		"names": ["Bini", "Edo"],
		"iso639-2": "bin",
		"iso639-1": null
	},
	"Bislama": {
		"name": "Bislama",
		"names": ["Bislama"],
		"iso639-2": "bis",
		"iso639-1": "bi"
	},
	"Blin": {
		"name": "Blin",
		"names": ["Blin", "Bilin"],
		"iso639-2": "byn",
		"iso639-1": null
	},
	"Bliss": {
		"name": "Bliss",
		"names": ["Blissymbols", "Blissymbolics", "Bliss"],
		"iso639-2": "zbl",
		"iso639-1": null
	},
	"Blissymbolics": {
		"name": "Blissymbolics",
		"names": ["Blissymbols", "Blissymbolics", "Bliss"],
		"iso639-2": "zbl",
		"iso639-1": null
	},
	"Blissymbols": {
		"name": "Blissymbols",
		"names": ["Blissymbols", "Blissymbolics", "Bliss"],
		"iso639-2": "zbl",
		"iso639-1": null
	},
	"Bokmål, Norwegian": {
		"name": "Bokmål, Norwegian",
		"names": ["Bokmål, Norwegian", "Norwegian Bokmål"],
		"iso639-2": "nob",
		"iso639-1": "nb"
	},
	"Bosnian": {
		"name": "Bosnian",
		"names": ["Bosnian"],
		"iso639-2": "bos",
		"iso639-1": "bs"
	},
	"Braj": {
		"name": "Braj",
		"names": ["Braj"],
		"iso639-2": "bra",
		"iso639-1": null
	},
	"Breton": {
		"name": "Breton",
		"names": ["Breton"],
		"iso639-2": "bre",
		"iso639-1": "br"
	},
	"Buginese": {
		"name": "Buginese",
		"names": ["Buginese"],
		"iso639-2": "bug",
		"iso639-1": null
	},
	"Bulgarian": {
		"name": "Bulgarian",
		"names": ["Bulgarian"],
		"iso639-2": "bul",
		"iso639-1": "bg"
	},
	"Buriat": {
		"name": "Buriat",
		"names": ["Buriat"],
		"iso639-2": "bua",
		"iso639-1": null
	},
	"Burmese": {
		"name": "Burmese",
		"names": ["Burmese"],
		"iso639-2": "bur/mya",
		"iso639-1": "my"
	},
	"Caddo": {
		"name": "Caddo",
		"names": ["Caddo"],
		"iso639-2": "cad",
		"iso639-1": null
	},
	"Castilian": {
		"name": "Castilian",
		"names": ["Spanish", "Castilian"],
		"iso639-2": "spa",
		"iso639-1": "es"
	},
	"Catalan": {
		"name": "Catalan",
		"names": ["Catalan", "Valencian"],
		"iso639-2": "cat",
		"iso639-1": "ca"
	},
	"Caucasian languages": {
		"name": "Caucasian languages",
		"names": ["Caucasian languages"],
		"iso639-2": "cau",
		"iso639-1": null
	},
	"Cebuano": {
		"name": "Cebuano",
		"names": ["Cebuano"],
		"iso639-2": "ceb",
		"iso639-1": null
	},
	"Celtic languages": {
		"name": "Celtic languages",
		"names": ["Celtic languages"],
		"iso639-2": "cel",
		"iso639-1": null
	},
	"Central American Indian languages": {
		"name": "Central American Indian languages",
		"names": ["Central American Indian languages"],
		"iso639-2": "cai",
		"iso639-1": null
	},
	"Central Khmer": {
		"name": "Central Khmer",
		"names": ["Central Khmer"],
		"iso639-2": "khm",
		"iso639-1": "km"
	},
	"Chagatai": {
		"name": "Chagatai",
		"names": ["Chagatai"],
		"iso639-2": "chg",
		"iso639-1": null
	},
	"Chamic languages": {
		"name": "Chamic languages",
		"names": ["Chamic languages"],
		"iso639-2": "cmc",
		"iso639-1": null
	},
	"Chamorro": {
		"name": "Chamorro",
		"names": ["Chamorro"],
		"iso639-2": "cha",
		"iso639-1": "ch"
	},
	"Chechen": {
		"name": "Chechen",
		"names": ["Chechen"],
		"iso639-2": "che",
		"iso639-1": "ce"
	},
	"Cherokee": {
		"name": "Cherokee",
		"names": ["Cherokee"],
		"iso639-2": "chr",
		"iso639-1": null
	},
	"Chewa": {
		"name": "Chewa",
		"names": ["Chichewa", "Chewa", "Nyanja"],
		"iso639-2": "nya",
		"iso639-1": "ny"
	},
	"Cheyenne": {
		"name": "Cheyenne",
		"names": ["Cheyenne"],
		"iso639-2": "chy",
		"iso639-1": null
	},
	"Chibcha": {
		"name": "Chibcha",
		"names": ["Chibcha"],
		"iso639-2": "chb",
		"iso639-1": null
	},
	"Chichewa": {
		"name": "Chichewa",
		"names": ["Chichewa", "Chewa", "Nyanja"],
		"iso639-2": "nya",
		"iso639-1": "ny"
	},
	"Chinese": {
		"name": "Chinese",
		"names": ["Chinese"],
		"iso639-2": "chi/zho",
		"iso639-1": "zh"
	},
	"Chinook jargon": {
		"name": "Chinook jargon",
		"names": ["Chinook jargon"],
		"iso639-2": "chn",
		"iso639-1": null
	},
	"Chipewyan": {
		"name": "Chipewyan",
		"names": ["Chipewyan", "Dene Suline"],
		"iso639-2": "chp",
		"iso639-1": null
	},
	"Choctaw": {
		"name": "Choctaw",
		"names": ["Choctaw"],
		"iso639-2": "cho",
		"iso639-1": null
	},
	"Chuang": {
		"name": "Chuang",
		"names": ["Zhuang", "Chuang"],
		"iso639-2": "zha",
		"iso639-1": "za"
	},
	"Church Slavic": {
		"name": "Church Slavic",
		"names": ["Church Slavic", "Old Slavonic", "Church Slavonic", "Old Bulgarian", "Old Church Slavonic"],
		"iso639-2": "chu",
		"iso639-1": "cu"
	},
	"Church Slavonic": {
		"name": "Church Slavonic",
		"names": ["Church Slavic", "Old Slavonic", "Church Slavonic", "Old Bulgarian", "Old Church Slavonic"],
		"iso639-2": "chu",
		"iso639-1": "cu"
	},
	"Chuukese": {
		"name": "Chuukese",
		"names": ["Chuukese"],
		"iso639-2": "chk",
		"iso639-1": null
	},
	"Chuvash": {
		"name": "Chuvash",
		"names": ["Chuvash"],
		"iso639-2": "chv",
		"iso639-1": "cv"
	},
	"Classical Nepal Bhasa": {
		"name": "Classical Nepal Bhasa",
		"names": ["Classical Newari", "Old Newari", "Classical Nepal Bhasa"],
		"iso639-2": "nwc",
		"iso639-1": null
	},
	"Classical Newari": {
		"name": "Classical Newari",
		"names": ["Classical Newari", "Old Newari", "Classical Nepal Bhasa"],
		"iso639-2": "nwc",
		"iso639-1": null
	},
	"Classical Syriac": {
		"name": "Classical Syriac",
		"names": ["Classical Syriac"],
		"iso639-2": "syc",
		"iso639-1": null
	},
	"Cook Islands Maori": {
		"name": "Cook Islands Maori",
		"names": ["Rarotongan", "Cook Islands Maori"],
		"iso639-2": "rar",
		"iso639-1": null
	},
	"Coptic": {
		"name": "Coptic",
		"names": ["Coptic"],
		"iso639-2": "cop",
		"iso639-1": null
	},
	"Cornish": {
		"name": "Cornish",
		"names": ["Cornish"],
		"iso639-2": "cor",
		"iso639-1": "kw"
	},
	"Corsican": {
		"name": "Corsican",
		"names": ["Corsican"],
		"iso639-2": "cos",
		"iso639-1": "co"
	},
	"Cree": {
		"name": "Cree",
		"names": ["Cree"],
		"iso639-2": "cre",
		"iso639-1": "cr"
	},
	"Creek": {
		"name": "Creek",
		"names": ["Creek"],
		"iso639-2": "mus",
		"iso639-1": null
	},
	"Creoles and pidgins": {
		"name": "Creoles and pidgins",
		"names": ["Creoles and pidgins"],
		"iso639-2": "crp",
		"iso639-1": null
	},
	"Creoles and pidgins, English based": {
		"name": "Creoles and pidgins, English based",
		"names": ["Creoles and pidgins, English based"],
		"iso639-2": "cpe",
		"iso639-1": null
	},
	"Creoles and pidgins, French-based": {
		"name": "Creoles and pidgins, French-based",
		"names": ["Creoles and pidgins, French-based"],
		"iso639-2": "cpf",
		"iso639-1": null
	},
	"Creoles and pidgins, Portuguese-based": {
		"name": "Creoles and pidgins, Portuguese-based",
		"names": ["Creoles and pidgins, Portuguese-based"],
		"iso639-2": "cpp",
		"iso639-1": null
	},
	"Crimean Tatar": {
		"name": "Crimean Tatar",
		"names": ["Crimean Tatar", "Crimean Turkish"],
		"iso639-2": "crh",
		"iso639-1": null
	},
	"Crimean Turkish": {
		"name": "Crimean Turkish",
		"names": ["Crimean Tatar", "Crimean Turkish"],
		"iso639-2": "crh",
		"iso639-1": null
	},
	"Croatian": {
		"name": "Croatian",
		"names": ["Croatian"],
		"iso639-2": "hrv",
		"iso639-1": "hr"
	},
	"Cushitic languages": {
		"name": "Cushitic languages",
		"names": ["Cushitic languages"],
		"iso639-2": "cus",
		"iso639-1": null
	},
	"Czech": {
		"name": "Czech",
		"names": ["Czech"],
		"iso639-2": "cze/ces",
		"iso639-1": "cs"
	},
	"Dakota": {
		"name": "Dakota",
		"names": ["Dakota"],
		"iso639-2": "dak",
		"iso639-1": null
	},
	"Danish": {
		"name": "Danish",
		"names": ["Danish"],
		"iso639-2": "dan",
		"iso639-1": "da"
	},
	"Dargwa": {
		"name": "Dargwa",
		"names": ["Dargwa"],
		"iso639-2": "dar",
		"iso639-1": null
	},
	"Delaware": {
		"name": "Delaware",
		"names": ["Delaware"],
		"iso639-2": "del",
		"iso639-1": null
	},
	"Dene Suline": {
		"name": "Dene Suline",
		"names": ["Chipewyan", "Dene Suline"],
		"iso639-2": "chp",
		"iso639-1": null
	},
	"Dhivehi": {
		"name": "Dhivehi",
		"names": ["Divehi", "Dhivehi", "Maldivian"],
		"iso639-2": "div",
		"iso639-1": "dv"
	},
	"Dimili": {
		"name": "Dimili",
		"names": ["Zaza", "Dimili", "Dimli", "Kirdki", "Kirmanjki", "Zazaki"],
		"iso639-2": "zza",
		"iso639-1": null
	},
	"Dimli": {
		"name": "Dimli",
		"names": ["Zaza", "Dimili", "Dimli", "Kirdki", "Kirmanjki", "Zazaki"],
		"iso639-2": "zza",
		"iso639-1": null
	},
	"Dinka": {
		"name": "Dinka",
		"names": ["Dinka"],
		"iso639-2": "din",
		"iso639-1": null
	},
	"Divehi": {
		"name": "Divehi",
		"names": ["Divehi", "Dhivehi", "Maldivian"],
		"iso639-2": "div",
		"iso639-1": "dv"
	},
	"Dogri": {
		"name": "Dogri",
		"names": ["Dogri"],
		"iso639-2": "doi",
		"iso639-1": null
	},
	"Dogrib": {
		"name": "Dogrib",
		"names": ["Dogrib"],
		"iso639-2": "dgr",
		"iso639-1": null
	},
	"Dravidian languages": {
		"name": "Dravidian languages",
		"names": ["Dravidian languages"],
		"iso639-2": "dra",
		"iso639-1": null
	},
	"Duala": {
		"name": "Duala",
		"names": ["Duala"],
		"iso639-2": "dua",
		"iso639-1": null
	},
	"Dutch": {
		"name": "Dutch",
		"names": ["Dutch", "Flemish"],
		"iso639-2": "dut/nld",
		"iso639-1": "nl"
	},
	"Dutch, Middle (ca.1050-1350)": {
		"name": "Dutch, Middle (ca.1050-1350)",
		"names": ["Dutch, Middle (ca.1050-1350)"],
		"iso639-2": "dum",
		"iso639-1": null
	},
	"Dyula": {
		"name": "Dyula",
		"names": ["Dyula"],
		"iso639-2": "dyu",
		"iso639-1": null
	},
	"Dzongkha": {
		"name": "Dzongkha",
		"names": ["Dzongkha"],
		"iso639-2": "dzo",
		"iso639-1": "dz"
	},
	"Eastern Frisian": {
		"name": "Eastern Frisian",
		"names": ["Eastern Frisian"],
		"iso639-2": "frs",
		"iso639-1": null
	},
	"Edo": {
		"name": "Edo",
		"names": ["Bini", "Edo"],
		"iso639-2": "bin",
		"iso639-1": null
	},
	"Efik": {
		"name": "Efik",
		"names": ["Efik"],
		"iso639-2": "efi",
		"iso639-1": null
	},
	"Egyptian (Ancient)": {
		"name": "Egyptian (Ancient)",
		"names": ["Egyptian (Ancient)"],
		"iso639-2": "egy",
		"iso639-1": null
	},
	"Ekajuk": {
		"name": "Ekajuk",
		"names": ["Ekajuk"],
		"iso639-2": "eka",
		"iso639-1": null
	},
	"Elamite": {
		"name": "Elamite",
		"names": ["Elamite"],
		"iso639-2": "elx",
		"iso639-1": null
	},
	"English": {
		"name": "English",
		"names": ["English"],
		"iso639-2": "eng",
		"iso639-1": "en"
	},
	"English, Middle (1100-1500)": {
		"name": "English, Middle (1100-1500)",
		"names": ["English, Middle (1100-1500)"],
		"iso639-2": "enm",
		"iso639-1": null
	},
	"English, Old (ca.450-1100)": {
		"name": "English, Old (ca.450-1100)",
		"names": ["English, Old (ca.450-1100)"],
		"iso639-2": "ang",
		"iso639-1": null
	},
	"Erzya": {
		"name": "Erzya",
		"names": ["Erzya"],
		"iso639-2": "myv",
		"iso639-1": null
	},
	"Esperanto": {
		"name": "Esperanto",
		"names": ["Esperanto"],
		"iso639-2": "epo",
		"iso639-1": "eo"
	},
	"Estonian": {
		"name": "Estonian",
		"names": ["Estonian"],
		"iso639-2": "est",
		"iso639-1": "et"
	},
	"Ewe": {
		"name": "Ewe",
		"names": ["Ewe"],
		"iso639-2": "ewe",
		"iso639-1": "ee"
	},
	"Ewondo": {
		"name": "Ewondo",
		"names": ["Ewondo"],
		"iso639-2": "ewo",
		"iso639-1": null
	},
	"Fang": {
		"name": "Fang",
		"names": ["Fang"],
		"iso639-2": "fan",
		"iso639-1": null
	},
	"Fanti": {
		"name": "Fanti",
		"names": ["Fanti"],
		"iso639-2": "fat",
		"iso639-1": null
	},
	"Faroese": {
		"name": "Faroese",
		"names": ["Faroese"],
		"iso639-2": "fao",
		"iso639-1": "fo"
	},
	"Fijian": {
		"name": "Fijian",
		"names": ["Fijian"],
		"iso639-2": "fij",
		"iso639-1": "fj"
	},
	"Filipino": {
		"name": "Filipino",
		"names": ["Filipino", "Pilipino"],
		"iso639-2": "fil",
		"iso639-1": null
	},
	"Finnish": {
		"name": "Finnish",
		"names": ["Finnish"],
		"iso639-2": "fin",
		"iso639-1": "fi"
	},
	"Finno-Ugrian languages": {
		"name": "Finno-Ugrian languages",
		"names": ["Finno-Ugrian languages"],
		"iso639-2": "fiu",
		"iso639-1": null
	},
	"Flemish": {
		"name": "Flemish",
		"names": ["Dutch", "Flemish"],
		"iso639-2": "dut/nld",
		"iso639-1": "nl"
	},
	"Fon": {
		"name": "Fon",
		"names": ["Fon"],
		"iso639-2": "fon",
		"iso639-1": null
	},
	"French": {
		"name": "French",
		"names": ["French"],
		"iso639-2": "fre/fra",
		"iso639-1": "fr"
	},
	"French, Middle (ca.1400-1600)": {
		"name": "French, Middle (ca.1400-1600)",
		"names": ["French, Middle (ca.1400-1600)"],
		"iso639-2": "frm",
		"iso639-1": null
	},
	"French, Old (842-ca.1400)": {
		"name": "French, Old (842-ca.1400)",
		"names": ["French, Old (842-ca.1400)"],
		"iso639-2": "fro",
		"iso639-1": null
	},
	"Friulian": {
		"name": "Friulian",
		"names": ["Friulian"],
		"iso639-2": "fur",
		"iso639-1": null
	},
	"Fulah": {
		"name": "Fulah",
		"names": ["Fulah"],
		"iso639-2": "ful",
		"iso639-1": "ff"
	},
	"Ga": {
		"name": "Ga",
		"names": ["Ga"],
		"iso639-2": "gaa",
		"iso639-1": null
	},
	"Gaelic": {
		"name": "Gaelic",
		"names": ["Gaelic", "Scottish Gaelic"],
		"iso639-2": "gla",
		"iso639-1": "gd"
	},
	"Galibi Carib": {
		"name": "Galibi Carib",
		"names": ["Galibi Carib"],
		"iso639-2": "car",
		"iso639-1": null
	},
	"Galician": {
		"name": "Galician",
		"names": ["Galician"],
		"iso639-2": "glg",
		"iso639-1": "gl"
	},
	"Ganda": {
		"name": "Ganda",
		"names": ["Ganda"],
		"iso639-2": "lug",
		"iso639-1": "lg"
	},
	"Gayo": {
		"name": "Gayo",
		"names": ["Gayo"],
		"iso639-2": "gay",
		"iso639-1": null
	},
	"Gbaya": {
		"name": "Gbaya",
		"names": ["Gbaya"],
		"iso639-2": "gba",
		"iso639-1": null
	},
	"Geez": {
		"name": "Geez",
		"names": ["Geez"],
		"iso639-2": "gez",
		"iso639-1": null
	},
	"Georgian": {
		"name": "Georgian",
		"names": ["Georgian"],
		"iso639-2": "geo/kat",
		"iso639-1": "ka"
	},
	"German": {
		"name": "German",
		"names": ["German"],
		"iso639-2": "ger/deu",
		"iso639-1": "de"
	},
	"German, Low": {
		"name": "German, Low",
		"names": ["Low German", "Low Saxon", "German, Low", "Saxon, Low"],
		"iso639-2": "nds",
		"iso639-1": null
	},
	"German, Middle High (ca.1050-1500)": {
		"name": "German, Middle High (ca.1050-1500)",
		"names": ["German, Middle High (ca.1050-1500)"],
		"iso639-2": "gmh",
		"iso639-1": null
	},
	"German, Old High (ca.750-1050)": {
		"name": "German, Old High (ca.750-1050)",
		"names": ["German, Old High (ca.750-1050)"],
		"iso639-2": "goh",
		"iso639-1": null
	},
	"Germanic languages": {
		"name": "Germanic languages",
		"names": ["Germanic languages"],
		"iso639-2": "gem",
		"iso639-1": null
	},
	"Gikuyu": {
		"name": "Gikuyu",
		"names": ["Kikuyu", "Gikuyu"],
		"iso639-2": "kik",
		"iso639-1": "ki"
	},
	"Gilbertese": {
		"name": "Gilbertese",
		"names": ["Gilbertese"],
		"iso639-2": "gil",
		"iso639-1": null
	},
	"Gondi": {
		"name": "Gondi",
		"names": ["Gondi"],
		"iso639-2": "gon",
		"iso639-1": null
	},
	"Gorontalo": {
		"name": "Gorontalo",
		"names": ["Gorontalo"],
		"iso639-2": "gor",
		"iso639-1": null
	},
	"Gothic": {
		"name": "Gothic",
		"names": ["Gothic"],
		"iso639-2": "got",
		"iso639-1": null
	},
	"Grebo": {
		"name": "Grebo",
		"names": ["Grebo"],
		"iso639-2": "grb",
		"iso639-1": null
	},
	"Greek, Ancient (to 1453)": {
		"name": "Greek, Ancient (to 1453)",
		"names": ["Greek, Ancient (to 1453)"],
		"iso639-2": "grc",
		"iso639-1": null
	},
	"Greek, Modern (1453-)": {
		"name": "Greek, Modern (1453-)",
		"names": ["Greek, Modern (1453-)"],
		"iso639-2": "gre/ell",
		"iso639-1": "el"
	},
	"Greenlandic": {
		"name": "Greenlandic",
		"names": ["Kalaallisut", "Greenlandic"],
		"iso639-2": "kal",
		"iso639-1": "kl"
	},
	"Guarani": {
		"name": "Guarani",
		"names": ["Guarani"],
		"iso639-2": "grn",
		"iso639-1": "gn"
	},
	"Gujarati": {
		"name": "Gujarati",
		"names": ["Gujarati"],
		"iso639-2": "guj",
		"iso639-1": "gu"
	},
	"Gwich'in": {
		"name": "Gwich'in",
		"names": ["Gwich'in"],
		"iso639-2": "gwi",
		"iso639-1": null
	},
	"Haida": {
		"name": "Haida",
		"names": ["Haida"],
		"iso639-2": "hai",
		"iso639-1": null
	},
	"Haitian": {
		"name": "Haitian",
		"names": ["Haitian", "Haitian Creole"],
		"iso639-2": "hat",
		"iso639-1": "ht"
	},
	"Haitian Creole": {
		"name": "Haitian Creole",
		"names": ["Haitian", "Haitian Creole"],
		"iso639-2": "hat",
		"iso639-1": "ht"
	},
	"Hausa": {
		"name": "Hausa",
		"names": ["Hausa"],
		"iso639-2": "hau",
		"iso639-1": "ha"
	},
	"Hawaiian": {
		"name": "Hawaiian",
		"names": ["Hawaiian"],
		"iso639-2": "haw",
		"iso639-1": null
	},
	"Hebrew": {
		"name": "Hebrew",
		"names": ["Hebrew"],
		"iso639-2": "heb",
		"iso639-1": "he"
	},
	"Herero": {
		"name": "Herero",
		"names": ["Herero"],
		"iso639-2": "her",
		"iso639-1": "hz"
	},
	"Hiligaynon": {
		"name": "Hiligaynon",
		"names": ["Hiligaynon"],
		"iso639-2": "hil",
		"iso639-1": null
	},
	"Himachali languages": {
		"name": "Himachali languages",
		"names": ["Himachali languages", "Western Pahari languages"],
		"iso639-2": "him",
		"iso639-1": null
	},
	"Hindi": {
		"name": "Hindi",
		"names": ["Hindi"],
		"iso639-2": "hin",
		"iso639-1": "hi"
	},
	"Hiri Motu": {
		"name": "Hiri Motu",
		"names": ["Hiri Motu"],
		"iso639-2": "hmo",
		"iso639-1": "ho"
	},
	"Hittite": {
		"name": "Hittite",
		"names": ["Hittite"],
		"iso639-2": "hit",
		"iso639-1": null
	},
	"Hmong": {
		"name": "Hmong",
		"names": ["Hmong", "Mong"],
		"iso639-2": "hmn",
		"iso639-1": null
	},
	"Hungarian": {
		"name": "Hungarian",
		"names": ["Hungarian"],
		"iso639-2": "hun",
		"iso639-1": "hu"
	},
	"Hupa": {
		"name": "Hupa",
		"names": ["Hupa"],
		"iso639-2": "hup",
		"iso639-1": null
	},
	"Iban": {
		"name": "Iban",
		"names": ["Iban"],
		"iso639-2": "iba",
		"iso639-1": null
	},
	"Icelandic": {
		"name": "Icelandic",
		"names": ["Icelandic"],
		"iso639-2": "ice/isl",
		"iso639-1": "is"
	},
	"Ido": {
		"name": "Ido",
		"names": ["Ido"],
		"iso639-2": "ido",
		"iso639-1": "io"
	},
	"Igbo": {
		"name": "Igbo",
		"names": ["Igbo"],
		"iso639-2": "ibo",
		"iso639-1": "ig"
	},
	"Ijo languages": {
		"name": "Ijo languages",
		"names": ["Ijo languages"],
		"iso639-2": "ijo",
		"iso639-1": null
	},
	"Iloko": {
		"name": "Iloko",
		"names": ["Iloko"],
		"iso639-2": "ilo",
		"iso639-1": null
	},
	"Imperial Aramaic (700-300 BCE)": {
		"name": "Imperial Aramaic (700-300 BCE)",
		"names": ["Official Aramaic (700-300 BCE)", "Imperial Aramaic (700-300 BCE)"],
		"iso639-2": "arc",
		"iso639-1": null
	},
	"Inari Sami": {
		"name": "Inari Sami",
		"names": ["Inari Sami"],
		"iso639-2": "smn",
		"iso639-1": null
	},
	"Indic languages": {
		"name": "Indic languages",
		"names": ["Indic languages"],
		"iso639-2": "inc",
		"iso639-1": null
	},
	"Indo-European languages": {
		"name": "Indo-European languages",
		"names": ["Indo-European languages"],
		"iso639-2": "ine",
		"iso639-1": null
	},
	"Indonesian": {
		"name": "Indonesian",
		"names": ["Indonesian"],
		"iso639-2": "ind",
		"iso639-1": "id"
	},
	"Ingush": {
		"name": "Ingush",
		"names": ["Ingush"],
		"iso639-2": "inh",
		"iso639-1": null
	},
	"Interlingua (International Auxiliary Language Association)": {
		"name": "Interlingua (International Auxiliary Language Association)",
		"names": ["Interlingua (International Auxiliary Language Association)"],
		"iso639-2": "ina",
		"iso639-1": "ia"
	},
	"Interlingue": {
		"name": "Interlingue",
		"names": ["Interlingue", "Occidental"],
		"iso639-2": "ile",
		"iso639-1": "ie"
	},
	"Inuktitut": {
		"name": "Inuktitut",
		"names": ["Inuktitut"],
		"iso639-2": "iku",
		"iso639-1": "iu"
	},
	"Inupiaq": {
		"name": "Inupiaq",
		"names": ["Inupiaq"],
		"iso639-2": "ipk",
		"iso639-1": "ik"
	},
	"Iranian languages": {
		"name": "Iranian languages",
		"names": ["Iranian languages"],
		"iso639-2": "ira",
		"iso639-1": null
	},
	"Irish": {
		"name": "Irish",
		"names": ["Irish"],
		"iso639-2": "gle",
		"iso639-1": "ga"
	},
	"Irish, Middle (900-1200)": {
		"name": "Irish, Middle (900-1200)",
		"names": ["Irish, Middle (900-1200)"],
		"iso639-2": "mga",
		"iso639-1": null
	},
	"Irish, Old (to 900)": {
		"name": "Irish, Old (to 900)",
		"names": ["Irish, Old (to 900)"],
		"iso639-2": "sga",
		"iso639-1": null
	},
	"Iroquoian languages": {
		"name": "Iroquoian languages",
		"names": ["Iroquoian languages"],
		"iso639-2": "iro",
		"iso639-1": null
	},
	"Italian": {
		"name": "Italian",
		"names": ["Italian"],
		"iso639-2": "ita",
		"iso639-1": "it"
	},
	"Japanese": {
		"name": "Japanese",
		"names": ["Japanese"],
		"iso639-2": "jpn",
		"iso639-1": "ja"
	},
	"Javanese": {
		"name": "Javanese",
		"names": ["Javanese"],
		"iso639-2": "jav",
		"iso639-1": "jv"
	},
	"Jingpho": {
		"name": "Jingpho",
		"names": ["Kachin", "Jingpho"],
		"iso639-2": "kac",
		"iso639-1": null
	},
	"Judeo-Arabic": {
		"name": "Judeo-Arabic",
		"names": ["Judeo-Arabic"],
		"iso639-2": "jrb",
		"iso639-1": null
	},
	"Judeo-Persian": {
		"name": "Judeo-Persian",
		"names": ["Judeo-Persian"],
		"iso639-2": "jpr",
		"iso639-1": null
	},
	"Kabardian": {
		"name": "Kabardian",
		"names": ["Kabardian"],
		"iso639-2": "kbd",
		"iso639-1": null
	},
	"Kabyle": {
		"name": "Kabyle",
		"names": ["Kabyle"],
		"iso639-2": "kab",
		"iso639-1": null
	},
	"Kachin": {
		"name": "Kachin",
		"names": ["Kachin", "Jingpho"],
		"iso639-2": "kac",
		"iso639-1": null
	},
	"Kalaallisut": {
		"name": "Kalaallisut",
		"names": ["Kalaallisut", "Greenlandic"],
		"iso639-2": "kal",
		"iso639-1": "kl"
	},
	"Kalmyk": {
		"name": "Kalmyk",
		"names": ["Kalmyk", "Oirat"],
		"iso639-2": "xal",
		"iso639-1": null
	},
	"Kamba": {
		"name": "Kamba",
		"names": ["Kamba"],
		"iso639-2": "kam",
		"iso639-1": null
	},
	"Kannada": {
		"name": "Kannada",
		"names": ["Kannada"],
		"iso639-2": "kan",
		"iso639-1": "kn"
	},
	"Kanuri": {
		"name": "Kanuri",
		"names": ["Kanuri"],
		"iso639-2": "kau",
		"iso639-1": "kr"
	},
	"Kapampangan": {
		"name": "Kapampangan",
		"names": ["Pampanga", "Kapampangan"],
		"iso639-2": "pam",
		"iso639-1": null
	},
	"Kara-Kalpak": {
		"name": "Kara-Kalpak",
		"names": ["Kara-Kalpak"],
		"iso639-2": "kaa",
		"iso639-1": null
	},
	"Karachay-Balkar": {
		"name": "Karachay-Balkar",
		"names": ["Karachay-Balkar"],
		"iso639-2": "krc",
		"iso639-1": null
	},
	"Karelian": {
		"name": "Karelian",
		"names": ["Karelian"],
		"iso639-2": "krl",
		"iso639-1": null
	},
	"Karen languages": {
		"name": "Karen languages",
		"names": ["Karen languages"],
		"iso639-2": "kar",
		"iso639-1": null
	},
	"Kashmiri": {
		"name": "Kashmiri",
		"names": ["Kashmiri"],
		"iso639-2": "kas",
		"iso639-1": "ks"
	},
	"Kashubian": {
		"name": "Kashubian",
		"names": ["Kashubian"],
		"iso639-2": "csb",
		"iso639-1": null
	},
	"Kawi": {
		"name": "Kawi",
		"names": ["Kawi"],
		"iso639-2": "kaw",
		"iso639-1": null
	},
	"Kazakh": {
		"name": "Kazakh",
		"names": ["Kazakh"],
		"iso639-2": "kaz",
		"iso639-1": "kk"
	},
	"Khasi": {
		"name": "Khasi",
		"names": ["Khasi"],
		"iso639-2": "kha",
		"iso639-1": null
	},
	"Khoisan languages": {
		"name": "Khoisan languages",
		"names": ["Khoisan languages"],
		"iso639-2": "khi",
		"iso639-1": null
	},
	"Khotanese": {
		"name": "Khotanese",
		"names": ["Khotanese", "Sakan"],
		"iso639-2": "kho",
		"iso639-1": null
	},
	"Kikuyu": {
		"name": "Kikuyu",
		"names": ["Kikuyu", "Gikuyu"],
		"iso639-2": "kik",
		"iso639-1": "ki"
	},
	"Kimbundu": {
		"name": "Kimbundu",
		"names": ["Kimbundu"],
		"iso639-2": "kmb",
		"iso639-1": null
	},
	"Kinyarwanda": {
		"name": "Kinyarwanda",
		"names": ["Kinyarwanda"],
		"iso639-2": "kin",
		"iso639-1": "rw"
	},
	"Kirdki": {
		"name": "Kirdki",
		"names": ["Zaza", "Dimili", "Dimli", "Kirdki", "Kirmanjki", "Zazaki"],
		"iso639-2": "zza",
		"iso639-1": null
	},
	"Kirghiz": {
		"name": "Kirghiz",
		"names": ["Kirghiz", "Kyrgyz"],
		"iso639-2": "kir",
		"iso639-1": "ky"
	},
	"Kirmanjki": {
		"name": "Kirmanjki",
		"names": ["Zaza", "Dimili", "Dimli", "Kirdki", "Kirmanjki", "Zazaki"],
		"iso639-2": "zza",
		"iso639-1": null
	},
	"Klingon": {
		"name": "Klingon",
		"names": ["Klingon", "tlhIngan-Hol"],
		"iso639-2": "tlh",
		"iso639-1": null
	},
	"Komi": {
		"name": "Komi",
		"names": ["Komi"],
		"iso639-2": "kom",
		"iso639-1": "kv"
	},
	"Kongo": {
		"name": "Kongo",
		"names": ["Kongo"],
		"iso639-2": "kon",
		"iso639-1": "kg"
	},
	"Konkani": {
		"name": "Konkani",
		"names": ["Konkani"],
		"iso639-2": "kok",
		"iso639-1": null
	},
	"Korean": {
		"name": "Korean",
		"names": ["Korean"],
		"iso639-2": "kor",
		"iso639-1": "ko"
	},
	"Kosraean": {
		"name": "Kosraean",
		"names": ["Kosraean"],
		"iso639-2": "kos",
		"iso639-1": null
	},
	"Kpelle": {
		"name": "Kpelle",
		"names": ["Kpelle"],
		"iso639-2": "kpe",
		"iso639-1": null
	},
	"Kru languages": {
		"name": "Kru languages",
		"names": ["Kru languages"],
		"iso639-2": "kro",
		"iso639-1": null
	},
	"Kuanyama": {
		"name": "Kuanyama",
		"names": ["Kuanyama", "Kwanyama"],
		"iso639-2": "kua",
		"iso639-1": "kj"
	},
	"Kumyk": {
		"name": "Kumyk",
		"names": ["Kumyk"],
		"iso639-2": "kum",
		"iso639-1": null
	},
	"Kurdish": {
		"name": "Kurdish",
		"names": ["Kurdish"],
		"iso639-2": "kur",
		"iso639-1": "ku"
	},
	"Kurukh": {
		"name": "Kurukh",
		"names": ["Kurukh"],
		"iso639-2": "kru",
		"iso639-1": null
	},
	"Kutenai": {
		"name": "Kutenai",
		"names": ["Kutenai"],
		"iso639-2": "kut",
		"iso639-1": null
	},
	"Kwanyama": {
		"name": "Kwanyama",
		"names": ["Kuanyama", "Kwanyama"],
		"iso639-2": "kua",
		"iso639-1": "kj"
	},
	"Kyrgyz": {
		"name": "Kyrgyz",
		"names": ["Kirghiz", "Kyrgyz"],
		"iso639-2": "kir",
		"iso639-1": "ky"
	},
	"Ladino": {
		"name": "Ladino",
		"names": ["Ladino"],
		"iso639-2": "lad",
		"iso639-1": null
	},
	"Lahnda": {
		"name": "Lahnda",
		"names": ["Lahnda"],
		"iso639-2": "lah",
		"iso639-1": null
	},
	"Lamba": {
		"name": "Lamba",
		"names": ["Lamba"],
		"iso639-2": "lam",
		"iso639-1": null
	},
	"Land Dayak languages": {
		"name": "Land Dayak languages",
		"names": ["Land Dayak languages"],
		"iso639-2": "day",
		"iso639-1": null
	},
	"Lao": {
		"name": "Lao",
		"names": ["Lao"],
		"iso639-2": "lao",
		"iso639-1": "lo"
	},
	"Latin": {
		"name": "Latin",
		"names": ["Latin"],
		"iso639-2": "lat",
		"iso639-1": "la"
	},
	"Latvian": {
		"name": "Latvian",
		"names": ["Latvian"],
		"iso639-2": "lav",
		"iso639-1": "lv"
	},
	"Leonese": {
		"name": "Leonese",
		"names": ["Asturian", "Bable", "Leonese", "Asturleonese"],
		"iso639-2": "ast",
		"iso639-1": null
	},
	"Letzeburgesch": {
		"name": "Letzeburgesch",
		"names": ["Luxembourgish", "Letzeburgesch"],
		"iso639-2": "ltz",
		"iso639-1": "lb"
	},
	"Lezghian": {
		"name": "Lezghian",
		"names": ["Lezghian"],
		"iso639-2": "lez",
		"iso639-1": null
	},
	"Limburgan": {
		"name": "Limburgan",
		"names": ["Limburgan", "Limburger", "Limburgish"],
		"iso639-2": "lim",
		"iso639-1": "li"
	},
	"Limburger": {
		"name": "Limburger",
		"names": ["Limburgan", "Limburger", "Limburgish"],
		"iso639-2": "lim",
		"iso639-1": "li"
	},
	"Limburgish": {
		"name": "Limburgish",
		"names": ["Limburgan", "Limburger", "Limburgish"],
		"iso639-2": "lim",
		"iso639-1": "li"
	},
	"Lingala": {
		"name": "Lingala",
		"names": ["Lingala"],
		"iso639-2": "lin",
		"iso639-1": "ln"
	},
	"Lithuanian": {
		"name": "Lithuanian",
		"names": ["Lithuanian"],
		"iso639-2": "lit",
		"iso639-1": "lt"
	},
	"Lojban": {
		"name": "Lojban",
		"names": ["Lojban"],
		"iso639-2": "jbo",
		"iso639-1": null
	},
	"Low German": {
		"name": "Low German",
		"names": ["Low German", "Low Saxon", "German, Low", "Saxon, Low"],
		"iso639-2": "nds",
		"iso639-1": null
	},
	"Low Saxon": {
		"name": "Low Saxon",
		"names": ["Low German", "Low Saxon", "German, Low", "Saxon, Low"],
		"iso639-2": "nds",
		"iso639-1": null
	},
	"Lower Sorbian": {
		"name": "Lower Sorbian",
		"names": ["Lower Sorbian"],
		"iso639-2": "dsb",
		"iso639-1": null
	},
	"Lozi": {
		"name": "Lozi",
		"names": ["Lozi"],
		"iso639-2": "loz",
		"iso639-1": null
	},
	"Luba-Katanga": {
		"name": "Luba-Katanga",
		"names": ["Luba-Katanga"],
		"iso639-2": "lub",
		"iso639-1": "lu"
	},
	"Luba-Lulua": {
		"name": "Luba-Lulua",
		"names": ["Luba-Lulua"],
		"iso639-2": "lua",
		"iso639-1": null
	},
	"Luiseno": {
		"name": "Luiseno",
		"names": ["Luiseno"],
		"iso639-2": "lui",
		"iso639-1": null
	},
	"Lule Sami": {
		"name": "Lule Sami",
		"names": ["Lule Sami"],
		"iso639-2": "smj",
		"iso639-1": null
	},
	"Lunda": {
		"name": "Lunda",
		"names": ["Lunda"],
		"iso639-2": "lun",
		"iso639-1": null
	},
	"Luo (Kenya and Tanzania)": {
		"name": "Luo (Kenya and Tanzania)",
		"names": ["Luo (Kenya and Tanzania)"],
		"iso639-2": "luo",
		"iso639-1": null
	},
	"Lushai": {
		"name": "Lushai",
		"names": ["Lushai"],
		"iso639-2": "lus",
		"iso639-1": null
	},
	"Luxembourgish": {
		"name": "Luxembourgish",
		"names": ["Luxembourgish", "Letzeburgesch"],
		"iso639-2": "ltz",
		"iso639-1": "lb"
	},
	"Macedo-Romanian": {
		"name": "Macedo-Romanian",
		"names": ["Aromanian", "Arumanian", "Macedo-Romanian"],
		"iso639-2": "rup",
		"iso639-1": null
	},
	"Macedonian": {
		"name": "Macedonian",
		"names": ["Macedonian"],
		"iso639-2": "mac/mkd",
		"iso639-1": "mk"
	},
	"Madurese": {
		"name": "Madurese",
		"names": ["Madurese"],
		"iso639-2": "mad",
		"iso639-1": null
	},
	"Magahi": {
		"name": "Magahi",
		"names": ["Magahi"],
		"iso639-2": "mag",
		"iso639-1": null
	},
	"Maithili": {
		"name": "Maithili",
		"names": ["Maithili"],
		"iso639-2": "mai",
		"iso639-1": null
	},
	"Makasar": {
		"name": "Makasar",
		"names": ["Makasar"],
		"iso639-2": "mak",
		"iso639-1": null
	},
	"Malagasy": {
		"name": "Malagasy",
		"names": ["Malagasy"],
		"iso639-2": "mlg",
		"iso639-1": "mg"
	},
	"Malay": {
		"name": "Malay",
		"names": ["Malay"],
		"iso639-2": "may/msa",
		"iso639-1": "ms"
	},
	"Malayalam": {
		"name": "Malayalam",
		"names": ["Malayalam"],
		"iso639-2": "mal",
		"iso639-1": "ml"
	},
	"Maldivian": {
		"name": "Maldivian",
		"names": ["Divehi", "Dhivehi", "Maldivian"],
		"iso639-2": "div",
		"iso639-1": "dv"
	},
	"Maltese": {
		"name": "Maltese",
		"names": ["Maltese"],
		"iso639-2": "mlt",
		"iso639-1": "mt"
	},
	"Manchu": {
		"name": "Manchu",
		"names": ["Manchu"],
		"iso639-2": "mnc",
		"iso639-1": null
	},
	"Mandar": {
		"name": "Mandar",
		"names": ["Mandar"],
		"iso639-2": "mdr",
		"iso639-1": null
	},
	"Mandingo": {
		"name": "Mandingo",
		"names": ["Mandingo"],
		"iso639-2": "man",
		"iso639-1": null
	},
	"Manipuri": {
		"name": "Manipuri",
		"names": ["Manipuri"],
		"iso639-2": "mni",
		"iso639-1": null
	},
	"Manobo languages": {
		"name": "Manobo languages",
		"names": ["Manobo languages"],
		"iso639-2": "mno",
		"iso639-1": null
	},
	"Manx": {
		"name": "Manx",
		"names": ["Manx"],
		"iso639-2": "glv",
		"iso639-1": "gv"
	},
	"Maori": {
		"name": "Maori",
		"names": ["Maori"],
		"iso639-2": "mao/mri",
		"iso639-1": "mi"
	},
	"Mapuche": {
		"name": "Mapuche",
		"names": ["Mapudungun", "Mapuche"],
		"iso639-2": "arn",
		"iso639-1": null
	},
	"Mapudungun": {
		"name": "Mapudungun",
		"names": ["Mapudungun", "Mapuche"],
		"iso639-2": "arn",
		"iso639-1": null
	},
	"Marathi": {
		"name": "Marathi",
		"names": ["Marathi"],
		"iso639-2": "mar",
		"iso639-1": "mr"
	},
	"Mari": {
		"name": "Mari",
		"names": ["Mari"],
		"iso639-2": "chm",
		"iso639-1": null
	},
	"Marshallese": {
		"name": "Marshallese",
		"names": ["Marshallese"],
		"iso639-2": "mah",
		"iso639-1": "mh"
	},
	"Marwari": {
		"name": "Marwari",
		"names": ["Marwari"],
		"iso639-2": "mwr",
		"iso639-1": null
	},
	"Masai": {
		"name": "Masai",
		"names": ["Masai"],
		"iso639-2": "mas",
		"iso639-1": null
	},
	"Mayan languages": {
		"name": "Mayan languages",
		"names": ["Mayan languages"],
		"iso639-2": "myn",
		"iso639-1": null
	},
	"Mende": {
		"name": "Mende",
		"names": ["Mende"],
		"iso639-2": "men",
		"iso639-1": null
	},
	"Mi'kmaq": {
		"name": "Mi'kmaq",
		"names": ["Mi'kmaq", "Micmac"],
		"iso639-2": "mic",
		"iso639-1": null
	},
	"Micmac": {
		"name": "Micmac",
		"names": ["Mi'kmaq", "Micmac"],
		"iso639-2": "mic",
		"iso639-1": null
	},
	"Minangkabau": {
		"name": "Minangkabau",
		"names": ["Minangkabau"],
		"iso639-2": "min",
		"iso639-1": null
	},
	"Mirandese": {
		"name": "Mirandese",
		"names": ["Mirandese"],
		"iso639-2": "mwl",
		"iso639-1": null
	},
	"Mohawk": {
		"name": "Mohawk",
		"names": ["Mohawk"],
		"iso639-2": "moh",
		"iso639-1": null
	},
	"Moksha": {
		"name": "Moksha",
		"names": ["Moksha"],
		"iso639-2": "mdf",
		"iso639-1": null
	},
	"Moldavian": {
		"name": "Moldavian",
		"names": ["Romanian", "Moldavian", "Moldovan"],
		"iso639-2": "rum/ron",
		"iso639-1": "ro"
	},
	"Moldovan": {
		"name": "Moldovan",
		"names": ["Romanian", "Moldavian", "Moldovan"],
		"iso639-2": "rum/ron",
		"iso639-1": "ro"
	},
	"Mon-Khmer languages": {
		"name": "Mon-Khmer languages",
		"names": ["Mon-Khmer languages"],
		"iso639-2": "mkh",
		"iso639-1": null
	},
	"Mong": {
		"name": "Mong",
		"names": ["Hmong", "Mong"],
		"iso639-2": "hmn",
		"iso639-1": null
	},
	"Mongo": {
		"name": "Mongo",
		"names": ["Mongo"],
		"iso639-2": "lol",
		"iso639-1": null
	},
	"Mongolian": {
		"name": "Mongolian",
		"names": ["Mongolian"],
		"iso639-2": "mon",
		"iso639-1": "mn"
	},
	"Montenegrin": {
		"name": "Montenegrin",
		"names": ["Montenegrin"],
		"iso639-2": "cnr",
		"iso639-1": null
	},
	"Mossi": {
		"name": "Mossi",
		"names": ["Mossi"],
		"iso639-2": "mos",
		"iso639-1": null
	},
	"Multiple languages": {
		"name": "Multiple languages",
		"names": ["Multiple languages"],
		"iso639-2": "mul",
		"iso639-1": null
	},
	"Munda languages": {
		"name": "Munda languages",
		"names": ["Munda languages"],
		"iso639-2": "mun",
		"iso639-1": null
	},
	"N'Ko": {
		"name": "N'Ko",
		"names": ["N'Ko"],
		"iso639-2": "nqo",
		"iso639-1": null
	},
	"Nahuatl languages": {
		"name": "Nahuatl languages",
		"names": ["Nahuatl languages"],
		"iso639-2": "nah",
		"iso639-1": null
	},
	"Nauru": {
		"name": "Nauru",
		"names": ["Nauru"],
		"iso639-2": "nau",
		"iso639-1": "na"
	},
	"Navaho": {
		"name": "Navaho",
		"names": ["Navajo", "Navaho"],
		"iso639-2": "nav",
		"iso639-1": "nv"
	},
	"Navajo": {
		"name": "Navajo",
		"names": ["Navajo", "Navaho"],
		"iso639-2": "nav",
		"iso639-1": "nv"
	},
	"Ndebele, North": {
		"name": "Ndebele, North",
		"names": ["Ndebele, North", "North Ndebele"],
		"iso639-2": "nde",
		"iso639-1": "nd"
	},
	"Ndebele, South": {
		"name": "Ndebele, South",
		"names": ["Ndebele, South", "South Ndebele"],
		"iso639-2": "nbl",
		"iso639-1": "nr"
	},
	"Ndonga": {
		"name": "Ndonga",
		"names": ["Ndonga"],
		"iso639-2": "ndo",
		"iso639-1": "ng"
	},
	"Neapolitan": {
		"name": "Neapolitan",
		"names": ["Neapolitan"],
		"iso639-2": "nap",
		"iso639-1": null
	},
	"Nepal Bhasa": {
		"name": "Nepal Bhasa",
		"names": ["Nepal Bhasa", "Newari"],
		"iso639-2": "new",
		"iso639-1": null
	},
	"Nepali": {
		"name": "Nepali",
		"names": ["Nepali"],
		"iso639-2": "nep",
		"iso639-1": "ne"
	},
	"Newari": {
		"name": "Newari",
		"names": ["Nepal Bhasa", "Newari"],
		"iso639-2": "new",
		"iso639-1": null
	},
	"Nias": {
		"name": "Nias",
		"names": ["Nias"],
		"iso639-2": "nia",
		"iso639-1": null
	},
	"Niger-Kordofanian languages": {
		"name": "Niger-Kordofanian languages",
		"names": ["Niger-Kordofanian languages"],
		"iso639-2": "nic",
		"iso639-1": null
	},
	"Nilo-Saharan languages": {
		"name": "Nilo-Saharan languages",
		"names": ["Nilo-Saharan languages"],
		"iso639-2": "ssa",
		"iso639-1": null
	},
	"Niuean": {
		"name": "Niuean",
		"names": ["Niuean"],
		"iso639-2": "niu",
		"iso639-1": null
	},
	"No linguistic content": {
		"name": "No linguistic content",
		"names": ["No linguistic content", "Not applicable"],
		"iso639-2": "zxx",
		"iso639-1": null
	},
	"Nogai": {
		"name": "Nogai",
		"names": ["Nogai"],
		"iso639-2": "nog",
		"iso639-1": null
	},
	"Norse, Old": {
		"name": "Norse, Old",
		"names": ["Norse, Old"],
		"iso639-2": "non",
		"iso639-1": null
	},
	"North American Indian languages": {
		"name": "North American Indian languages",
		"names": ["North American Indian languages"],
		"iso639-2": "nai",
		"iso639-1": null
	},
	"North Ndebele": {
		"name": "North Ndebele",
		"names": ["Ndebele, North", "North Ndebele"],
		"iso639-2": "nde",
		"iso639-1": "nd"
	},
	"Northern Frisian": {
		"name": "Northern Frisian",
		"names": ["Northern Frisian"],
		"iso639-2": "frr",
		"iso639-1": null
	},
	"Northern Sami": {
		"name": "Northern Sami",
		"names": ["Northern Sami"],
		"iso639-2": "sme",
		"iso639-1": "se"
	},
	"Northern Sotho": {
		"name": "Northern Sotho",
		"names": ["Pedi", "Sepedi", "Northern Sotho"],
		"iso639-2": "nso",
		"iso639-1": null
	},
	"Norwegian": {
		"name": "Norwegian",
		"names": ["Norwegian"],
		"iso639-2": "nor",
		"iso639-1": "no"
	},
	"Norwegian Bokmål": {
		"name": "Norwegian Bokmål",
		"names": ["Bokmål, Norwegian", "Norwegian Bokmål"],
		"iso639-2": "nob",
		"iso639-1": "nb"
	},
	"Norwegian Nynorsk": {
		"name": "Norwegian Nynorsk",
		"names": ["Norwegian Nynorsk", "Nynorsk, Norwegian"],
		"iso639-2": "nno",
		"iso639-1": "nn"
	},
	"Not applicable": {
		"name": "Not applicable",
		"names": ["No linguistic content", "Not applicable"],
		"iso639-2": "zxx",
		"iso639-1": null
	},
	"Nubian languages": {
		"name": "Nubian languages",
		"names": ["Nubian languages"],
		"iso639-2": "nub",
		"iso639-1": null
	},
	"Nuosu": {
		"name": "Nuosu",
		"names": ["Sichuan Yi", "Nuosu"],
		"iso639-2": "iii",
		"iso639-1": "ii"
	},
	"Nyamwezi": {
		"name": "Nyamwezi",
		"names": ["Nyamwezi"],
		"iso639-2": "nym",
		"iso639-1": null
	},
	"Nyanja": {
		"name": "Nyanja",
		"names": ["Chichewa", "Chewa", "Nyanja"],
		"iso639-2": "nya",
		"iso639-1": "ny"
	},
	"Nyankole": {
		"name": "Nyankole",
		"names": ["Nyankole"],
		"iso639-2": "nyn",
		"iso639-1": null
	},
	"Nynorsk, Norwegian": {
		"name": "Nynorsk, Norwegian",
		"names": ["Norwegian Nynorsk", "Nynorsk, Norwegian"],
		"iso639-2": "nno",
		"iso639-1": "nn"
	},
	"Nyoro": {
		"name": "Nyoro",
		"names": ["Nyoro"],
		"iso639-2": "nyo",
		"iso639-1": null
	},
	"Nzima": {
		"name": "Nzima",
		"names": ["Nzima"],
		"iso639-2": "nzi",
		"iso639-1": null
	},
	"Occidental": {
		"name": "Occidental",
		"names": ["Interlingue", "Occidental"],
		"iso639-2": "ile",
		"iso639-1": "ie"
	},
	"Occitan (post 1500)": {
		"name": "Occitan (post 1500)",
		"names": ["Occitan (post 1500)"],
		"iso639-2": "oci",
		"iso639-1": "oc"
	},
	"Occitan, Old (to 1500)": {
		"name": "Occitan, Old (to 1500)",
		"names": ["Provençal, Old (to 1500)", "Occitan, Old (to 1500)"],
		"iso639-2": "pro",
		"iso639-1": null
	},
	"Official Aramaic (700-300 BCE)": {
		"name": "Official Aramaic (700-300 BCE)",
		"names": ["Official Aramaic (700-300 BCE)", "Imperial Aramaic (700-300 BCE)"],
		"iso639-2": "arc",
		"iso639-1": null
	},
	"Oirat": {
		"name": "Oirat",
		"names": ["Kalmyk", "Oirat"],
		"iso639-2": "xal",
		"iso639-1": null
	},
	"Ojibwa": {
		"name": "Ojibwa",
		"names": ["Ojibwa"],
		"iso639-2": "oji",
		"iso639-1": "oj"
	},
	"Old Bulgarian": {
		"name": "Old Bulgarian",
		"names": ["Church Slavic", "Old Slavonic", "Church Slavonic", "Old Bulgarian", "Old Church Slavonic"],
		"iso639-2": "chu",
		"iso639-1": "cu"
	},
	"Old Church Slavonic": {
		"name": "Old Church Slavonic",
		"names": ["Church Slavic", "Old Slavonic", "Church Slavonic", "Old Bulgarian", "Old Church Slavonic"],
		"iso639-2": "chu",
		"iso639-1": "cu"
	},
	"Old Newari": {
		"name": "Old Newari",
		"names": ["Classical Newari", "Old Newari", "Classical Nepal Bhasa"],
		"iso639-2": "nwc",
		"iso639-1": null
	},
	"Old Slavonic": {
		"name": "Old Slavonic",
		"names": ["Church Slavic", "Old Slavonic", "Church Slavonic", "Old Bulgarian", "Old Church Slavonic"],
		"iso639-2": "chu",
		"iso639-1": "cu"
	},
	"Oriya": {
		"name": "Oriya",
		"names": ["Oriya"],
		"iso639-2": "ori",
		"iso639-1": "or"
	},
	"Oromo": {
		"name": "Oromo",
		"names": ["Oromo"],
		"iso639-2": "orm",
		"iso639-1": "om"
	},
	"Osage": {
		"name": "Osage",
		"names": ["Osage"],
		"iso639-2": "osa",
		"iso639-1": null
	},
	"Ossetian": {
		"name": "Ossetian",
		"names": ["Ossetian", "Ossetic"],
		"iso639-2": "oss",
		"iso639-1": "os"
	},
	"Ossetic": {
		"name": "Ossetic",
		"names": ["Ossetian", "Ossetic"],
		"iso639-2": "oss",
		"iso639-1": "os"
	},
	"Otomian languages": {
		"name": "Otomian languages",
		"names": ["Otomian languages"],
		"iso639-2": "oto",
		"iso639-1": null
	},
	"Pahlavi": {
		"name": "Pahlavi",
		"names": ["Pahlavi"],
		"iso639-2": "pal",
		"iso639-1": null
	},
	"Palauan": {
		"name": "Palauan",
		"names": ["Palauan"],
		"iso639-2": "pau",
		"iso639-1": null
	},
	"Pali": {
		"name": "Pali",
		"names": ["Pali"],
		"iso639-2": "pli",
		"iso639-1": "pi"
	},
	"Pampanga": {
		"name": "Pampanga",
		"names": ["Pampanga", "Kapampangan"],
		"iso639-2": "pam",
		"iso639-1": null
	},
	"Pangasinan": {
		"name": "Pangasinan",
		"names": ["Pangasinan"],
		"iso639-2": "pag",
		"iso639-1": null
	},
	"Panjabi": {
		"name": "Panjabi",
		"names": ["Panjabi", "Punjabi"],
		"iso639-2": "pan",
		"iso639-1": "pa"
	},
	"Papiamento": {
		"name": "Papiamento",
		"names": ["Papiamento"],
		"iso639-2": "pap",
		"iso639-1": null
	},
	"Papuan languages": {
		"name": "Papuan languages",
		"names": ["Papuan languages"],
		"iso639-2": "paa",
		"iso639-1": null
	},
	"Pashto": {
		"name": "Pashto",
		"names": ["Pushto", "Pashto"],
		"iso639-2": "pus",
		"iso639-1": "ps"
	},
	"Pedi": {
		"name": "Pedi",
		"names": ["Pedi", "Sepedi", "Northern Sotho"],
		"iso639-2": "nso",
		"iso639-1": null
	},
	"Persian": {
		"name": "Persian",
		"names": ["Persian"],
		"iso639-2": "per/fas",
		"iso639-1": "fa"
	},
	"Persian, Old (ca.600-400 B.C.)": {
		"name": "Persian, Old (ca.600-400 B.C.)",
		"names": ["Persian, Old (ca.600-400 B.C.)"],
		"iso639-2": "peo",
		"iso639-1": null
	},
	"Philippine languages": {
		"name": "Philippine languages",
		"names": ["Philippine languages"],
		"iso639-2": "phi",
		"iso639-1": null
	},
	"Phoenician": {
		"name": "Phoenician",
		"names": ["Phoenician"],
		"iso639-2": "phn",
		"iso639-1": null
	},
	"Pilipino": {
		"name": "Pilipino",
		"names": ["Filipino", "Pilipino"],
		"iso639-2": "fil",
		"iso639-1": null
	},
	"Pohnpeian": {
		"name": "Pohnpeian",
		"names": ["Pohnpeian"],
		"iso639-2": "pon",
		"iso639-1": null
	},
	"Polish": {
		"name": "Polish",
		"names": ["Polish"],
		"iso639-2": "pol",
		"iso639-1": "pl"
	},
	"Portuguese": {
		"name": "Portuguese",
		"names": ["Portuguese"],
		"iso639-2": "por",
		"iso639-1": "pt"
	},
	"Prakrit languages": {
		"name": "Prakrit languages",
		"names": ["Prakrit languages"],
		"iso639-2": "pra",
		"iso639-1": null
	},
	"Provençal, Old (to 1500)": {
		"name": "Provençal, Old (to 1500)",
		"names": ["Provençal, Old (to 1500)", "Occitan, Old (to 1500)"],
		"iso639-2": "pro",
		"iso639-1": null
	},
	"Punjabi": {
		"name": "Punjabi",
		"names": ["Panjabi", "Punjabi"],
		"iso639-2": "pan",
		"iso639-1": "pa"
	},
	"Pushto": {
		"name": "Pushto",
		"names": ["Pushto", "Pashto"],
		"iso639-2": "pus",
		"iso639-1": "ps"
	},
	"Quechua": {
		"name": "Quechua",
		"names": ["Quechua"],
		"iso639-2": "que",
		"iso639-1": "qu"
	},
	"Rajasthani": {
		"name": "Rajasthani",
		"names": ["Rajasthani"],
		"iso639-2": "raj",
		"iso639-1": null
	},
	"Rapanui": {
		"name": "Rapanui",
		"names": ["Rapanui"],
		"iso639-2": "rap",
		"iso639-1": null
	},
	"Rarotongan": {
		"name": "Rarotongan",
		"names": ["Rarotongan", "Cook Islands Maori"],
		"iso639-2": "rar",
		"iso639-1": null
	},
	"Reserved for local use": {
		"name": "Reserved for local use",
		"names": ["Reserved for local use"],
		"iso639-2": "qaa-qtz",
		"iso639-1": null
	},
	"Romance languages": {
		"name": "Romance languages",
		"names": ["Romance languages"],
		"iso639-2": "roa",
		"iso639-1": null
	},
	"Romanian": {
		"name": "Romanian",
		"names": ["Romanian", "Moldavian", "Moldovan"],
		"iso639-2": "rum/ron",
		"iso639-1": "ro"
	},
	"Romansh": {
		"name": "Romansh",
		"names": ["Romansh"],
		"iso639-2": "roh",
		"iso639-1": "rm"
	},
	"Romany": {
		"name": "Romany",
		"names": ["Romany"],
		"iso639-2": "rom",
		"iso639-1": null
	},
	"Rundi": {
		"name": "Rundi",
		"names": ["Rundi"],
		"iso639-2": "run",
		"iso639-1": "rn"
	},
	"Russian": {
		"name": "Russian",
		"names": ["Russian"],
		"iso639-2": "rus",
		"iso639-1": "ru"
	},
	"Sakan": {
		"name": "Sakan",
		"names": ["Khotanese", "Sakan"],
		"iso639-2": "kho",
		"iso639-1": null
	},
	"Salishan languages": {
		"name": "Salishan languages",
		"names": ["Salishan languages"],
		"iso639-2": "sal",
		"iso639-1": null
	},
	"Samaritan Aramaic": {
		"name": "Samaritan Aramaic",
		"names": ["Samaritan Aramaic"],
		"iso639-2": "sam",
		"iso639-1": null
	},
	"Sami languages": {
		"name": "Sami languages",
		"names": ["Sami languages"],
		"iso639-2": "smi",
		"iso639-1": null
	},
	"Samoan": {
		"name": "Samoan",
		"names": ["Samoan"],
		"iso639-2": "smo",
		"iso639-1": "sm"
	},
	"Sandawe": {
		"name": "Sandawe",
		"names": ["Sandawe"],
		"iso639-2": "sad",
		"iso639-1": null
	},
	"Sango": {
		"name": "Sango",
		"names": ["Sango"],
		"iso639-2": "sag",
		"iso639-1": "sg"
	},
	"Sanskrit": {
		"name": "Sanskrit",
		"names": ["Sanskrit"],
		"iso639-2": "san",
		"iso639-1": "sa"
	},
	"Santali": {
		"name": "Santali",
		"names": ["Santali"],
		"iso639-2": "sat",
		"iso639-1": null
	},
	"Sardinian": {
		"name": "Sardinian",
		"names": ["Sardinian"],
		"iso639-2": "srd",
		"iso639-1": "sc"
	},
	"Sasak": {
		"name": "Sasak",
		"names": ["Sasak"],
		"iso639-2": "sas",
		"iso639-1": null
	},
	"Saxon, Low": {
		"name": "Saxon, Low",
		"names": ["Low German", "Low Saxon", "German, Low", "Saxon, Low"],
		"iso639-2": "nds",
		"iso639-1": null
	},
	"Scots": {
		"name": "Scots",
		"names": ["Scots"],
		"iso639-2": "sco",
		"iso639-1": null
	},
	"Scottish Gaelic": {
		"name": "Scottish Gaelic",
		"names": ["Gaelic", "Scottish Gaelic"],
		"iso639-2": "gla",
		"iso639-1": "gd"
	},
	"Selkup": {
		"name": "Selkup",
		"names": ["Selkup"],
		"iso639-2": "sel",
		"iso639-1": null
	},
	"Semitic languages": {
		"name": "Semitic languages",
		"names": ["Semitic languages"],
		"iso639-2": "sem",
		"iso639-1": null
	},
	"Sepedi": {
		"name": "Sepedi",
		"names": ["Pedi", "Sepedi", "Northern Sotho"],
		"iso639-2": "nso",
		"iso639-1": null
	},
	"Serbian": {
		"name": "Serbian",
		"names": ["Serbian"],
		"iso639-2": "srp",
		"iso639-1": "sr"
	},
	"Serer": {
		"name": "Serer",
		"names": ["Serer"],
		"iso639-2": "srr",
		"iso639-1": null
	},
	"Shan": {
		"name": "Shan",
		"names": ["Shan"],
		"iso639-2": "shn",
		"iso639-1": null
	},
	"Shona": {
		"name": "Shona",
		"names": ["Shona"],
		"iso639-2": "sna",
		"iso639-1": "sn"
	},
	"Sichuan Yi": {
		"name": "Sichuan Yi",
		"names": ["Sichuan Yi", "Nuosu"],
		"iso639-2": "iii",
		"iso639-1": "ii"
	},
	"Sicilian": {
		"name": "Sicilian",
		"names": ["Sicilian"],
		"iso639-2": "scn",
		"iso639-1": null
	},
	"Sidamo": {
		"name": "Sidamo",
		"names": ["Sidamo"],
		"iso639-2": "sid",
		"iso639-1": null
	},
	"Sign Languages": {
		"name": "Sign Languages",
		"names": ["Sign Languages"],
		"iso639-2": "sgn",
		"iso639-1": null
	},
	"Siksika": {
		"name": "Siksika",
		"names": ["Siksika"],
		"iso639-2": "bla",
		"iso639-1": null
	},
	"Sindhi": {
		"name": "Sindhi",
		"names": ["Sindhi"],
		"iso639-2": "snd",
		"iso639-1": "sd"
	},
	"Sinhala": {
		"name": "Sinhala",
		"names": ["Sinhala", "Sinhalese"],
		"iso639-2": "sin",
		"iso639-1": "si"
	},
	"Sinhalese": {
		"name": "Sinhalese",
		"names": ["Sinhala", "Sinhalese"],
		"iso639-2": "sin",
		"iso639-1": "si"
	},
	"Sino-Tibetan languages": {
		"name": "Sino-Tibetan languages",
		"names": ["Sino-Tibetan languages"],
		"iso639-2": "sit",
		"iso639-1": null
	},
	"Siouan languages": {
		"name": "Siouan languages",
		"names": ["Siouan languages"],
		"iso639-2": "sio",
		"iso639-1": null
	},
	"Skolt Sami": {
		"name": "Skolt Sami",
		"names": ["Skolt Sami"],
		"iso639-2": "sms",
		"iso639-1": null
	},
	"Slave (Athapascan)": {
		"name": "Slave (Athapascan)",
		"names": ["Slave (Athapascan)"],
		"iso639-2": "den",
		"iso639-1": null
	},
	"Slavic languages": {
		"name": "Slavic languages",
		"names": ["Slavic languages"],
		"iso639-2": "sla",
		"iso639-1": null
	},
	"Slovak": {
		"name": "Slovak",
		"names": ["Slovak"],
		"iso639-2": "slo/slk",
		"iso639-1": "sk"
	},
	"Slovenian": {
		"name": "Slovenian",
		"names": ["Slovenian"],
		"iso639-2": "slv",
		"iso639-1": "sl"
	},
	"Sogdian": {
		"name": "Sogdian",
		"names": ["Sogdian"],
		"iso639-2": "sog",
		"iso639-1": null
	},
	"Somali": {
		"name": "Somali",
		"names": ["Somali"],
		"iso639-2": "som",
		"iso639-1": "so"
	},
	"Songhai languages": {
		"name": "Songhai languages",
		"names": ["Songhai languages"],
		"iso639-2": "son",
		"iso639-1": null
	},
	"Soninke": {
		"name": "Soninke",
		"names": ["Soninke"],
		"iso639-2": "snk",
		"iso639-1": null
	},
	"Sorbian languages": {
		"name": "Sorbian languages",
		"names": ["Sorbian languages"],
		"iso639-2": "wen",
		"iso639-1": null
	},
	"Sotho, Northern": {
		"name": "Sotho, Northern",
		"names": ["Pedi", "Sepedi", "Northern Sotho"],
		"iso639-2": "nso",
		"iso639-1": null
	},
	"Sotho, Southern": {
		"name": "Sotho, Southern",
		"names": ["Sotho, Southern"],
		"iso639-2": "sot",
		"iso639-1": "st"
	},
	"South American Indian languages": {
		"name": "South American Indian languages",
		"names": ["South American Indian languages"],
		"iso639-2": "sai",
		"iso639-1": null
	},
	"South Ndebele": {
		"name": "South Ndebele",
		"names": ["Ndebele, South", "South Ndebele"],
		"iso639-2": "nbl",
		"iso639-1": "nr"
	},
	"Southern Altai": {
		"name": "Southern Altai",
		"names": ["Southern Altai"],
		"iso639-2": "alt",
		"iso639-1": null
	},
	"Southern Sami": {
		"name": "Southern Sami",
		"names": ["Southern Sami"],
		"iso639-2": "sma",
		"iso639-1": null
	},
	"Spanish": {
		"name": "Spanish",
		"names": ["Spanish", "Castilian"],
		"iso639-2": "spa",
		"iso639-1": "es"
	},
	"Sranan Tongo": {
		"name": "Sranan Tongo",
		"names": ["Sranan Tongo"],
		"iso639-2": "srn",
		"iso639-1": null
	},
	"Standard Moroccan Tamazight": {
		"name": "Standard Moroccan Tamazight",
		"names": ["Standard Moroccan Tamazight"],
		"iso639-2": "zgh",
		"iso639-1": null
	},
	"Sukuma": {
		"name": "Sukuma",
		"names": ["Sukuma"],
		"iso639-2": "suk",
		"iso639-1": null
	},
	"Sumerian": {
		"name": "Sumerian",
		"names": ["Sumerian"],
		"iso639-2": "sux",
		"iso639-1": null
	},
	"Sundanese": {
		"name": "Sundanese",
		"names": ["Sundanese"],
		"iso639-2": "sun",
		"iso639-1": "su"
	},
	"Susu": {
		"name": "Susu",
		"names": ["Susu"],
		"iso639-2": "sus",
		"iso639-1": null
	},
	"Swahili": {
		"name": "Swahili",
		"names": ["Swahili"],
		"iso639-2": "swa",
		"iso639-1": "sw"
	},
	"Swati": {
		"name": "Swati",
		"names": ["Swati"],
		"iso639-2": "ssw",
		"iso639-1": "ss"
	},
	"Swedish": {
		"name": "Swedish",
		"names": ["Swedish"],
		"iso639-2": "swe",
		"iso639-1": "sv"
	},
	"Swiss German": {
		"name": "Swiss German",
		"names": ["Swiss German", "Alemannic", "Alsatian"],
		"iso639-2": "gsw",
		"iso639-1": null
	},
	"Syriac": {
		"name": "Syriac",
		"names": ["Syriac"],
		"iso639-2": "syr",
		"iso639-1": null
	},
	"Tagalog": {
		"name": "Tagalog",
		"names": ["Tagalog"],
		"iso639-2": "tgl",
		"iso639-1": "tl"
	},
	"Tahitian": {
		"name": "Tahitian",
		"names": ["Tahitian"],
		"iso639-2": "tah",
		"iso639-1": "ty"
	},
	"Tai languages": {
		"name": "Tai languages",
		"names": ["Tai languages"],
		"iso639-2": "tai",
		"iso639-1": null
	},
	"Tajik": {
		"name": "Tajik",
		"names": ["Tajik"],
		"iso639-2": "tgk",
		"iso639-1": "tg"
	},
	"Tamashek": {
		"name": "Tamashek",
		"names": ["Tamashek"],
		"iso639-2": "tmh",
		"iso639-1": null
	},
	"Tamil": {
		"name": "Tamil",
		"names": ["Tamil"],
		"iso639-2": "tam",
		"iso639-1": "ta"
	},
	"Tatar": {
		"name": "Tatar",
		"names": ["Tatar"],
		"iso639-2": "tat",
		"iso639-1": "tt"
	},
	"Telugu": {
		"name": "Telugu",
		"names": ["Telugu"],
		"iso639-2": "tel",
		"iso639-1": "te"
	},
	"Tereno": {
		"name": "Tereno",
		"names": ["Tereno"],
		"iso639-2": "ter",
		"iso639-1": null
	},
	"Tetum": {
		"name": "Tetum",
		"names": ["Tetum"],
		"iso639-2": "tet",
		"iso639-1": null
	},
	"Thai": {
		"name": "Thai",
		"names": ["Thai"],
		"iso639-2": "tha",
		"iso639-1": "th"
	},
	"Tibetan": {
		"name": "Tibetan",
		"names": ["Tibetan"],
		"iso639-2": "tib/bod",
		"iso639-1": "bo"
	},
	"Tigre": {
		"name": "Tigre",
		"names": ["Tigre"],
		"iso639-2": "tig",
		"iso639-1": null
	},
	"Tigrinya": {
		"name": "Tigrinya",
		"names": ["Tigrinya"],
		"iso639-2": "tir",
		"iso639-1": "ti"
	},
	"Timne": {
		"name": "Timne",
		"names": ["Timne"],
		"iso639-2": "tem",
		"iso639-1": null
	},
	"Tiv": {
		"name": "Tiv",
		"names": ["Tiv"],
		"iso639-2": "tiv",
		"iso639-1": null
	},
	"tlhIngan-Hol": {
		"name": "tlhIngan-Hol",
		"names": ["Klingon", "tlhIngan-Hol"],
		"iso639-2": "tlh",
		"iso639-1": null
	},
	"Tlingit": {
		"name": "Tlingit",
		"names": ["Tlingit"],
		"iso639-2": "tli",
		"iso639-1": null
	},
	"Tok Pisin": {
		"name": "Tok Pisin",
		"names": ["Tok Pisin"],
		"iso639-2": "tpi",
		"iso639-1": null
	},
	"Tokelau": {
		"name": "Tokelau",
		"names": ["Tokelau"],
		"iso639-2": "tkl",
		"iso639-1": null
	},
	"Tonga (Nyasa)": {
		"name": "Tonga (Nyasa)",
		"names": ["Tonga (Nyasa)"],
		"iso639-2": "tog",
		"iso639-1": null
	},
	"Tonga (Tonga Islands)": {
		"name": "Tonga (Tonga Islands)",
		"names": ["Tonga (Tonga Islands)"],
		"iso639-2": "ton",
		"iso639-1": "to"
	},
	"Tsimshian": {
		"name": "Tsimshian",
		"names": ["Tsimshian"],
		"iso639-2": "tsi",
		"iso639-1": null
	},
	"Tsonga": {
		"name": "Tsonga",
		"names": ["Tsonga"],
		"iso639-2": "tso",
		"iso639-1": "ts"
	},
	"Tswana": {
		"name": "Tswana",
		"names": ["Tswana"],
		"iso639-2": "tsn",
		"iso639-1": "tn"
	},
	"Tumbuka": {
		"name": "Tumbuka",
		"names": ["Tumbuka"],
		"iso639-2": "tum",
		"iso639-1": null
	},
	"Tupi languages": {
		"name": "Tupi languages",
		"names": ["Tupi languages"],
		"iso639-2": "tup",
		"iso639-1": null
	},
	"Turkish": {
		"name": "Turkish",
		"names": ["Turkish"],
		"iso639-2": "tur",
		"iso639-1": "tr"
	},
	"Turkish, Ottoman (1500-1928)": {
		"name": "Turkish, Ottoman (1500-1928)",
		"names": ["Turkish, Ottoman (1500-1928)"],
		"iso639-2": "ota",
		"iso639-1": null
	},
	"Turkmen": {
		"name": "Turkmen",
		"names": ["Turkmen"],
		"iso639-2": "tuk",
		"iso639-1": "tk"
	},
	"Tuvalu": {
		"name": "Tuvalu",
		"names": ["Tuvalu"],
		"iso639-2": "tvl",
		"iso639-1": null
	},
	"Tuvinian": {
		"name": "Tuvinian",
		"names": ["Tuvinian"],
		"iso639-2": "tyv",
		"iso639-1": null
	},
	"Twi": {
		"name": "Twi",
		"names": ["Twi"],
		"iso639-2": "twi",
		"iso639-1": "tw"
	},
	"Udmurt": {
		"name": "Udmurt",
		"names": ["Udmurt"],
		"iso639-2": "udm",
		"iso639-1": null
	},
	"Ugaritic": {
		"name": "Ugaritic",
		"names": ["Ugaritic"],
		"iso639-2": "uga",
		"iso639-1": null
	},
	"Uighur": {
		"name": "Uighur",
		"names": ["Uighur", "Uyghur"],
		"iso639-2": "uig",
		"iso639-1": "ug"
	},
	"Ukrainian": {
		"name": "Ukrainian",
		"names": ["Ukrainian"],
		"iso639-2": "ukr",
		"iso639-1": "uk"
	},
	"Umbundu": {
		"name": "Umbundu",
		"names": ["Umbundu"],
		"iso639-2": "umb",
		"iso639-1": null
	},
	"Uncoded languages": {
		"name": "Uncoded languages",
		"names": ["Uncoded languages"],
		"iso639-2": "mis",
		"iso639-1": null
	},
	"Undetermined": {
		"name": "Undetermined",
		"names": ["Undetermined"],
		"iso639-2": "und",
		"iso639-1": null
	},
	"Upper Sorbian": {
		"name": "Upper Sorbian",
		"names": ["Upper Sorbian"],
		"iso639-2": "hsb",
		"iso639-1": null
	},
	"Urdu": {
		"name": "Urdu",
		"names": ["Urdu"],
		"iso639-2": "urd",
		"iso639-1": "ur"
	},
	"Uyghur": {
		"name": "Uyghur",
		"names": ["Uighur", "Uyghur"],
		"iso639-2": "uig",
		"iso639-1": "ug"
	},
	"Uzbek": {
		"name": "Uzbek",
		"names": ["Uzbek"],
		"iso639-2": "uzb",
		"iso639-1": "uz"
	},
	"Vai": {
		"name": "Vai",
		"names": ["Vai"],
		"iso639-2": "vai",
		"iso639-1": null
	},
	"Valencian": {
		"name": "Valencian",
		"names": ["Catalan", "Valencian"],
		"iso639-2": "cat",
		"iso639-1": "ca"
	},
	"Venda": {
		"name": "Venda",
		"names": ["Venda"],
		"iso639-2": "ven",
		"iso639-1": "ve"
	},
	"Vietnamese": {
		"name": "Vietnamese",
		"names": ["Vietnamese"],
		"iso639-2": "vie",
		"iso639-1": "vi"
	},
	"Volapük": {
		"name": "Volapük",
		"names": ["Volapük"],
		"iso639-2": "vol",
		"iso639-1": "vo"
	},
	"Votic": {
		"name": "Votic",
		"names": ["Votic"],
		"iso639-2": "vot",
		"iso639-1": null
	},
	"Wakashan languages": {
		"name": "Wakashan languages",
		"names": ["Wakashan languages"],
		"iso639-2": "wak",
		"iso639-1": null
	},
	"Walloon": {
		"name": "Walloon",
		"names": ["Walloon"],
		"iso639-2": "wln",
		"iso639-1": "wa"
	},
	"Waray": {
		"name": "Waray",
		"names": ["Waray"],
		"iso639-2": "war",
		"iso639-1": null
	},
	"Washo": {
		"name": "Washo",
		"names": ["Washo"],
		"iso639-2": "was",
		"iso639-1": null
	},
	"Welsh": {
		"name": "Welsh",
		"names": ["Welsh"],
		"iso639-2": "wel/cym",
		"iso639-1": "cy"
	},
	"Western Frisian": {
		"name": "Western Frisian",
		"names": ["Western Frisian"],
		"iso639-2": "fry",
		"iso639-1": "fy"
	},
	"Western Pahari languages": {
		"name": "Western Pahari languages",
		"names": ["Himachali languages", "Western Pahari languages"],
		"iso639-2": "him",
		"iso639-1": null
	},
	"Wolaitta": {
		"name": "Wolaitta",
		"names": ["Wolaitta", "Wolaytta"],
		"iso639-2": "wal",
		"iso639-1": null
	},
	"Wolaytta": {
		"name": "Wolaytta",
		"names": ["Wolaitta", "Wolaytta"],
		"iso639-2": "wal",
		"iso639-1": null
	},
	"Wolof": {
		"name": "Wolof",
		"names": ["Wolof"],
		"iso639-2": "wol",
		"iso639-1": "wo"
	},
	"Xhosa": {
		"name": "Xhosa",
		"names": ["Xhosa"],
		"iso639-2": "xho",
		"iso639-1": "xh"
	},
	"Yakut": {
		"name": "Yakut",
		"names": ["Yakut"],
		"iso639-2": "sah",
		"iso639-1": null
	},
	"Yao": {
		"name": "Yao",
		"names": ["Yao"],
		"iso639-2": "yao",
		"iso639-1": null
	},
	"Yapese": {
		"name": "Yapese",
		"names": ["Yapese"],
		"iso639-2": "yap",
		"iso639-1": null
	},
	"Yiddish": {
		"name": "Yiddish",
		"names": ["Yiddish"],
		"iso639-2": "yid",
		"iso639-1": "yi"
	},
	"Yoruba": {
		"name": "Yoruba",
		"names": ["Yoruba"],
		"iso639-2": "yor",
		"iso639-1": "yo"
	},
	"Yupik languages": {
		"name": "Yupik languages",
		"names": ["Yupik languages"],
		"iso639-2": "ypk",
		"iso639-1": null
	},
	"Zande languages": {
		"name": "Zande languages",
		"names": ["Zande languages"],
		"iso639-2": "znd",
		"iso639-1": null
	},
	"Zapotec": {
		"name": "Zapotec",
		"names": ["Zapotec"],
		"iso639-2": "zap",
		"iso639-1": null
	},
	"Zaza": {
		"name": "Zaza",
		"names": ["Zaza", "Dimili", "Dimli", "Kirdki", "Kirmanjki", "Zazaki"],
		"iso639-2": "zza",
		"iso639-1": null
	},
	"Zazaki": {
		"name": "Zazaki",
		"names": ["Zaza", "Dimili", "Dimli", "Kirdki", "Kirmanjki", "Zazaki"],
		"iso639-2": "zza",
		"iso639-1": null
	},
	"Zenaga": {
		"name": "Zenaga",
		"names": ["Zenaga"],
		"iso639-2": "zen",
		"iso639-1": null
	},
	"Zhuang": {
		"name": "Zhuang",
		"names": ["Zhuang", "Chuang"],
		"iso639-2": "zha",
		"iso639-1": "za"
	},
	"Zulu": {
		"name": "Zulu",
		"names": ["Zulu"],
		"iso639-2": "zul",
		"iso639-1": "zu"
	},
	"Zuni": {
		"name": "Zuni",
		"names": ["Zuni"],
		"iso639-2": "zun",
		"iso639-1": null
	}
}
